import { Alert, Link } from "@mui/material"
import * as styles from "./AppError.styles"

/**
 * Fallback UI component to show when error caught in error boundary
 */
const AppError = () => {
    return (
        <Alert severity="error" css={styles.error}>
            Oops, something went wrong. Please try again.{" "}
            <Link
                component="button"
                onClick={() => {
                    window.location.reload()
                }}
            >
                Reload
            </Link>
        </Alert>
    )
}

export default AppError
